import React from "react";
import useAsync from "../../utils/useAsync.js";
import { getStatement } from "../../utils/stockApi.js";
import { fmtCell } from "../../utils/format.js";
import { Loading, ErrorBox } from "./common.jsx";

// Condensed statement table for the Overview page: only the chosen rows and
// the most recent `cols` periods.
export default function MiniStatement({ ticker, statement, period, keys, cols = 8 }) {
  const { data, loading, error } = useAsync(
    () => getStatement(ticker, statement, period),
    [ticker, statement, period]
  );
  if (loading && !data) return <Loading />;
  if (error) return <ErrorBox error={error} />;

  const columns = data.columns.slice(-cols);
  const rows = keys.map((k) => data.rows.find((r) => r.key === k)).filter(Boolean);

  return (
    <div className="co-table-wrap">
      <table className="co-table">
        <thead>
          <tr>
            <th className="co-sticky">{statement === "ratios" ? "" : "USD millions"}</th>
            {columns.map((c) => (
              <th key={c.label}>{c.label}<small>{c.sub}</small></th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.key} className={`${r.bold ? "bold" : ""} ${r.italic ? "italic" : ""}`}>
              <td className={`co-sticky ${r.indent ? "indent" : ""}`}>{r.label}</td>
              {r.values.slice(-cols).map((v, i) => (
                <td key={i} className={v < 0 && r.kind !== "money" ? "neg" : ""}>{fmtCell(v, r.kind, "MM")}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}